import { render, staticRenderFns } from "./oz-icon.vue?vue&type=template&id=ea94d126&scoped=true&"
import script from "./oz-icon.vue?vue&type=script&lang=ts&"
export * from "./oz-icon.vue?vue&type=script&lang=ts&"
import style0 from "./oz-icon.vue?vue&type=style&index=0&id=ea94d126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea94d126",
  null
  
)

/* custom blocks */
import block0 from "./oz-icon.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports